import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceMgtService {

  constructor(private http: HttpClient) { }

  ReadDeviceMgtList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/mgt/list/read`, params);
  }

  DeleteDeviceSettingList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/delete`, params);
  }

  ReadDeviceDetails(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/detail/read`, params);
  }

  ReadDeviceAdminStatus(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/admin/device/read/status`, params);
  }
}
